import React from 'react';
import 'twin.macro';
import {
  useCountSelectedSeances,
  useResetSelectedPreviewSeances,
} from '../atom';
import Button from 'components/Buttons/Button';
import { XMarkIcon as X } from '@heroicons/react/24/outline';
import { InformationCircleIcon as InformationCircle } from '@heroicons/react/24/outline';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
  children?: React.ReactNode;
  daysWithEvents?: Date[];
}

export function Footer(props: Props) {
  const { onClose, children, daysWithEvents } = props;
  const { t } = useTranslation(['common', 'cahierJournal']);
  const count = useCountSelectedSeances();
  const resetSelectedSeances = useResetSelectedPreviewSeances();
  return (
    <div tw="flex items-center justify-end gap-x-6 w-full">
      {(daysWithEvents || []).length > 0 && count == 0 && (
        <div tw="text-muted hidden md:flex mr-auto items-center">
          <InformationCircle tw="h-5 w-5 mr-2" />
          {t(
            'cahierJournal:copyEventsToAnotherDayModal.footer.selectSpecificSeance',
          )}
        </div>
      )}
      {count > 0 && (
        <div tw="hidden md:flex gap-x-2.5 items-center mr-auto">
          <div>
            <Trans
              i18nKey="cahierJournal:copyEventsToAnotherDayModal.footer.nbOfSelectedSeances"
              count={count}
            >
              <strong>AA</strong>BB
            </Trans>
          </div>
          <div>
            <Button
              small
              iconSize="sm"
              minimal
              icon={X}
              onClick={() => resetSelectedSeances()}
            />
          </div>
        </div>
      )}
      <div tw="flex flex-shrink-0 items-center gap-x-2.5">
        <Button tw="hidden md:inline-block" large minimal onClick={onClose}>
          {t('common:buttons.cancel')}
        </Button>
        {children}
      </div>
    </div>
  );
}
